import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export let searchCurrentCustomers = async (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_CURRENT_CUSTORMER_API;

  let payload = {
    requestObject: {
      currentCustomerId: searchValues?.currentCustomerId,
      factoryName: searchValues?.factoryName,
      typeOfEstate: searchValues.typeOfEstate,
      customerGroupByEstateType: searchValues.customerGroupByEstateType,
      yearOfBudget: searchValues.yearOfBudget,
      monthOfBudget: searchValues.monthOfBudget,
      customerGroupByAge: searchValues.customerGroupByAge,
      customerGroupByRegion: searchValues.customerGroupByRegion,
      waterConsumptionMin: searchValues.waterConsumptionMin,
      waterConsumptionMax: searchValues.waterConsumptionMax,
      areaSizeByRaiMin: searchValues.areaSizeByRaiMin,
      areaSizeByRaiMax: searchValues.areaSizeByRaiMax,
      areaSizeByNganMin: searchValues.areaSizeByNganMin,
      areaSizeByNganMax: searchValues.areaSizeByNganMax,
      areaSizeByWaMin: searchValues.areaSizeByWaMin,
      areaSizeByWaMax: searchValues.areaSizeByWaMax,
      areaSizeByMetersMin: searchValues.areaSizeByMetersMin,
      areaSizeByMetersMax: searchValues.areaSizeByMetersMax,
      buyOrRentLand: searchValues.buyOrRentLand,
      productAndServiceWant: searchValues.productAndServiceWant,
      supportWant: searchValues.supportWant,
      transactionWant: searchValues.transactionWant,
      crmExpected: searchValues.crmExpected,
      lineOfWorkId: searchValues.lineOfWorkId, //[]
      countryId: searchValues.countryId,
      estateId: searchValues.estateId,
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = await axiosInstance.post(api, payload);

  return res;
};

export const getCurrentCustomerByID = (id) => {
  const api = APIEndpoint.GET_CURRENT_CUSTOMER_BY_ID_API + `/${id}`;
  const res = axiosInstance.get(api);
  return res;
};
export const getCurrentCustomerByIDForReport = (id) => {
  const api = APIEndpoint.GET_CURRENT_CUSTOMER_BY_ID_FOR_REPORT_INCLUDED_NON_KPI_API + `/${id}`;
  const res = axiosInstance.get(api);
  return res;
};
 
export const deleteCurrentCustomer = (id) => {
  const api =
    APIEndpoint.DELETE_CURRENT_CUSTOMER_API + `/?currentCustomerId=${id}`;
  const res = axiosInstance.delete(api);
  return res;
};

export const createCurrentCustomer = async (request) => {
  const payload = {
    requestObject: request,
  };

  const api = APIEndpoint.CREATE_CURRENT_CUSTOMER_API;
  const res = await axiosInstance.post(api, JSON.stringify(payload));
  return res;
};

export const updateCurrentCustomer = async (request) => {
  const payload = {
    requestObject: request,
  };
  const api = APIEndpoint.UPDATE_CURRENT_CUSTOMER_API;
  const res = await axiosInstance.put(api, JSON.stringify(payload));
  return res;
};

export const exportReport = async (payload) => {
  const api = APIEndpoint.EXPORT_REPORT_CURRENT_CUSTOMER;
  const config = {
    headers: {
      "content-type": "application/json",
    },
    responseType: "blob",
  };
  const res = await axiosInstance.post(api, payload, config);
  return res || false;
};

export const getListFactory = async (searchKey) => {
  const api = `${APIEndpoint.GET_LIST_FACTORY_API}`;
  let payload = {
    requestObject: {
      searchKey: searchKey ? searchKey : "",
    },
    pageValue: {
      page: 0,
      pageSize: 100,
      sortBy: "factoryNameEn",
      sortDirection: "DESC"
    }
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const searchProductAutoComplete = async (searchKey) => {
  const api = `${APIEndpoint.SEARCH_PRODUCT_API}`; 

  const payload = {
    requestObject: {
      searchKey: searchKey ?? "", 
    },
  };

  const res = await axiosInstance.post(api, payload);
  return res;
};

// CurrentCustomerGroupByEstateAndDbdRegister
export let searchCurrentCustomersEstateDbd = async (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_CURRENT_CUSTORMER_GroupBy_EstateAndDbd_API;

  let payload = {
    requestObject: {
      currentCustomerId: searchValues?.currentCustomerId,
      factoryName: searchValues?.factoryName,
      typeOfEstate: searchValues.typeOfEstate,
      customerGroupByEstateType: searchValues.customerGroupByEstateType,
      yearOfBudget: searchValues.yearOfBudget,
      monthOfBudget: searchValues.monthOfBudget,
      customerGroupByAge: searchValues.customerGroupByAge,
      customerGroupByRegion: searchValues.customerGroupByRegion,
      waterConsumptionMin: searchValues.waterConsumptionMin,
      waterConsumptionMax: searchValues.waterConsumptionMax,
      areaSizeByRaiMin: searchValues.areaSizeByRaiMin,
      areaSizeByRaiMax: searchValues.areaSizeByRaiMax,
      areaSizeByNganMin: searchValues.areaSizeByNganMin,
      areaSizeByNganMax: searchValues.areaSizeByNganMax,
      areaSizeByWaMin: searchValues.areaSizeByWaMin,
      areaSizeByWaMax: searchValues.areaSizeByWaMax,
      areaSizeByMetersMin: searchValues.areaSizeByMetersMin,
      areaSizeByMetersMax: searchValues.areaSizeByMetersMax,
      buyOrRentLand: searchValues.buyOrRentLand,
      productAndServiceWant: searchValues.productAndServiceWant,
      supportWant: searchValues.supportWant,
      transactionWant: searchValues.transactionWant,
      crmExpected: searchValues.crmExpected,
      lineOfWorkId: searchValues.lineOfWorkId, //[]
      countryId: searchValues.countryId,
      estateId: searchValues.estateId,
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = await axiosInstance.post(api, payload);

  return res;
};
export const getCurrentCustomerByEstateDbd = (dbdRegisterNumber,estateId) => {
  const api = APIEndpoint.GET_CURRENT_CUSTOMER_GroupBy_EstateAndDbd_BY_ID_API + `/${dbdRegisterNumber}/${estateId}`;
  const res = axiosInstance.get(api);
  return res;
};